import produce from 'immer'

import { Constants } from './'

const initialState = {
  sellersDrawerOpen: false,
  stockInfoDrawerOpen: false
}

const reducer = (state = initialState, action = {}) =>
  produce(state, draft => {
    switch (action.type) {
      case Constants.UI_SELLERS_DRAWER_TOGGLE:
        draft.sellersDrawerOpen = !state.sellersDrawerOpen

        break

      case Constants.UI_STOCKINFO_DRAWER_OPEN:
        draft.stockInfoDrawerOpen = true

        break

      case Constants.UI_STOCKINFO_DRAWER_CLOSE:
        draft.stockInfoDrawerOpen = false

        break

      default:
        return draft
    }
  })

export default reducer
